/**
 * Do not edit directly, this file was auto-generated.
 */

export const BORDER_WIDTH_XS = 1;
export const BORDER_WIDTH_SM = 2;
export const BORDER_WIDTH_MD = 4;
export const BORDER_WIDTH_BASE = 1;
export const BORDER_OUTLINE = {
  color: "var(--color-neutral-500, currentcolor)",
  width: 1,
  style: "solid",
};
export const BORDER_OUTLINE_OFFSET = 1;
export const BREAKPOINT_PHONE = 320;
export const BREAKPOINT_PHONE_LARGE = 385;
export const BREAKPOINT_TABLET = 768;
export const BREAKPOINT_TABLET_LARGE = 992;
export const BREAKPOINT_TABLET_LANDSCAPE = 1024;
export const BREAKPOINT_LAPTOP = 1280;
export const BREAKPOINT_DESKTOP = 1440;
export const BREAKPOINT_DESKTOP_LARGE = 2560;
export const COLOR_NEUTRAL_LIGHT_100 = "#d7d7d7ff";
export const COLOR_NEUTRAL_LIGHT_300 = "#e3e3e3ff";
export const COLOR_NEUTRAL_LIGHT_500 = "#ecececff";
export const COLOR_NEUTRAL_LIGHT_700 = "#f7f7f7ff";
export const COLOR_NEUTRAL_LIGHT_900 = "#ffffffff";
export const COLOR_NEUTRAL_DARK_100 = "#f5f1efff";
export const COLOR_NEUTRAL_DARK_300 = "#bab8b8ff";
export const COLOR_NEUTRAL_DARK_500 = "#888686ff";
export const COLOR_NEUTRAL_DARK_700 = "#353333ff";
export const COLOR_NEUTRAL_DARK_900 = "#242222ff";
export const COLOR_BRAND_FOREST_GREEN_25 = "#e9efebff";
export const COLOR_BRAND_FOREST_GREEN_50 = "#dfe5e1ff";
export const COLOR_BRAND_FOREST_GREEN_100 = "#d2ded9ff";
export const COLOR_BRAND_FOREST_GREEN_300 = "#a6beb3ff";
export const COLOR_BRAND_FOREST_GREEN_500 = "#799d8cff";
export const COLOR_BRAND_FOREST_GREEN_700 = "#205c40ff";
export const COLOR_BRAND_FOREST_GREEN_900 = "#284734ff";
export const COLOR_BRAND_DESERT_SAND_100 = "#eae4deff";
export const COLOR_BRAND_DESERT_SAND_300 = "#ded4caff";
export const COLOR_BRAND_DESERT_SAND_500 = "#ccc3baff";
export const COLOR_BRAND_DESERT_SAND_700 = "#96886dff";
export const COLOR_BRAND_DESERT_SAND_900 = "#867659ff";
export const COLOR_BRAND_WATER_BLUE_100 = "#d0d8dbff";
export const COLOR_BRAND_WATER_BLUE_300 = "#a2b2b7ff";
export const COLOR_BRAND_WATER_BLUE_500 = "#738b94ff";
export const COLOR_BRAND_WATER_BLUE_700 = "#456570ff";
export const COLOR_BRAND_WATER_BLUE_900 = "#2e5664ff";
export const COLOR_BRAND_WATER_PURPLE_500 = "#5b5a79ff";
export const COLOR_FEEDBACK_SUCCESS_100 = "#cdeaddff";
export const COLOR_FEEDBACK_SUCCESS_300 = "#9ad6bbff";
export const COLOR_FEEDBACK_SUCCESS_500 = "#68c199ff";
export const COLOR_FEEDBACK_SUCCESS_700 = "#35ad77ff";
export const COLOR_FEEDBACK_SUCCESS_900 = "#039855ff";
export const COLOR_FEEDBACK_ERROR_100 = "#e9d2d1ff";
export const COLOR_FEEDBACK_ERROR_300 = "#d3a6a3ff";
export const COLOR_FEEDBACK_ERROR_500 = "#bd7974ff";
export const COLOR_FEEDBACK_ERROR_700 = "#a74d46ff";
export const COLOR_FEEDBACK_ERROR_900 = "#912018ff";
export const COLOR_FEEDBACK_WARNING_100 = "#f8e1cdff";
export const COLOR_FEEDBACK_WARNING_300 = "#f1c39aff";
export const COLOR_FEEDBACK_WARNING_500 = "#eaa468ff";
export const COLOR_FEEDBACK_WARNING_700 = "#e38635ff";
export const COLOR_FEEDBACK_WARNING_900 = "#dc6803ff";
export const COLOR_FEEDBACK_WARNING_950 = "#975329ff";
export const COLOR_ALFA_LIGHT_0 = "#ffffff00";
export const COLOR_ALFA_LIGHT_8 = "#ffffff14";
export const COLOR_ALFA_LIGHT_16 = "#ffffff29";
export const COLOR_ALFA_LIGHT_24 = "#ffffff3d";
export const COLOR_ALFA_LIGHT_32 = "#ffffff52";
export const COLOR_ALFA_DARK_0 = "#00000000";
export const COLOR_ALFA_DARK_8 = "#00000014";
export const COLOR_ALFA_DARK_16 = "#00000029";
export const COLOR_ALFA_DARK_24 = "#0000003d";
export const COLOR_ALFA_DARK_32 = "#00000052";
export const COLOR_PRIMARY_BLACK = "#000000ff";
export const COLOR_CUSTOM_COLORS_ACCESSORIES_BACKGROUND = "#8a7c72ff";
export const SHADOW_SOFT = [
  {
    color: "rgb(26 25 25 / 8%)",
    offsetX: "0",
    offsetY: "0.5rem",
    blur: "1.5rem",
    spread: "0",
  },
];
export const SPACING_0 = 0;
export const SPACING_1 = 1;
export const SPACING_2 = 2;
export const SPACING_4 = 4;
export const SPACING_5 = 5;
export const SPACING_6 = 6;
export const SPACING_8 = 8;
export const SPACING_10 = 10;
export const SPACING_12 = 12;
export const SPACING_14 = 14;
export const SPACING_16 = 16;
export const SPACING_18 = 18;
export const SPACING_20 = 20;
export const SPACING_24 = 24;
export const SPACING_28 = 28;
export const SPACING_32 = 32;
export const SPACING_36 = 36;
export const SPACING_40 = 40;
export const SPACING_44 = 44;
export const SPACING_46 = 46;
export const SPACING_48 = 48;
export const SPACING_50 = 50;
export const SPACING_52 = 52;
export const SPACING_56 = 56;
export const SPACING_64 = 64;
export const SPACING_72 = 72;
export const SPACING_80 = 80;
export const SPACING_84 = 84;
export const SPACING_88 = 88;
export const SPACING_96 = 96;
export const SPACING_104 = 104;
export const SPACING_112 = 112;
export const SPACING_120 = 120;
export const SPACING_128 = 128;
export const SPACING_136 = 136;
export const SPACING_140 = 140;
export const SPACING_156 = 156;
export const SPACING_160 = 160;
export const SPACING_168 = 168;
export const SPACING_172 = 172;
export const SPACING_176 = 176;
export const SPACING_181 = 181;
export const SPACING_184 = 184;
export const SPACING_192 = 192;
export const SPACING_200 = 200;
export const SPACING_240 = 240;
export const SPACING_248 = 248;
export const SPACING_256 = 256;
export const SPACING_264 = 264;
export const SPACING_280 = 280;
export const SPACING_300 = 300;
export const SPACING_304 = 304;
export const SPACING_320 = 320;
export const SPACING_344 = 344;
export const SPACING_360 = 360;
export const SPACING_368 = 368;
export const SPACING_384 = 384;
export const SPACING_400 = 400;
export const SPACING_424 = 424;
export const SPACING_440 = 440;
export const SPACING_456 = 456;
export const SPACING_480 = 480;
export const SPACING_520 = 520;
export const SPACING_552 = 552;
export const SPACING_560 = 560;
export const SPACING_594 = 594;
export const SPACING_600 = 600;
export const SPACING_640 = 640;
export const SPACING_668 = 668;
export const SPACING_694 = 694;
export const SPACING_758 = 758;
export const SPACING_800 = 800;
export const SPACING_840 = 840;
export const SPACING_880 = 880;
export const SPACING_960 = 960;
export const SPACING_1024 = 1024;
export const SPACING_1320 = 1320;
export const SPACING_1512 = 1512;
export const SPACING_1920 = 1920;
export const SPACING_BASE = 16;
export const RADIUS_XS = 2;
export const RADIUS_SM = 4;
export const RADIUS_MD = 8;
export const RADIUS_LG = 12;
export const RADIUS_XL = 16;
export const RADIUS_XXL = 24;
export const RADIUS_4XL = 40;
export const RADIUS_CIRCLE = "50%";
export const RADIUS_BASE = 8;
export const ZINDEX_BELOW = -1;
export const ZINDEX_ZERO = 0;
export const ZINDEX_ABOVE = 1;
export const ZINDEX_FOREGROUND = 2;
export const ZINDEX_BANNER = 5;
export const ZINDEX_HEADER = 10;
export const ZINDEX_SEARCH = 15;
export const ZINDEX_DIALOG = 20;
export const GUTTER_MOBILE = 24;
export const GUTTER_TABLET = 48;
export const GUTTER_DESKTOP = 96;
export const GUTTER_DESKTOP_LARGE = 320;
export const MAX_WIDTH_DESKTOP = "calc(1320 + 96 * 2)";
export const MAX_WIDTH_DESKTOP_LARGE = "calc(1920 + 320 * 2)";
export const TRANSITION_FAST_IN = {
  duration: 150,
  delay: 0,
  timingFunction: [0.5, 0, 1, 1],
};
export const TRANSITION_FAST_OUT = {
  duration: 150,
  delay: 0,
  timingFunction: [0, 0, 0.5, 1],
};
export const TRANSITION_EASING_ACCELERATE = [0.5, 0, 1, 1];
export const TRANSITION_EASING_DECELERATE = [0, 0, 0.5, 1];
export const TRANSITION_EASING_IN_OUT_CUBIC = [0.65, 0, 0.35, 1];
export const TRANSITION_DELAY_INSTANT = 0;
export const TRANSITION_DELAY_SHORT = 100;
export const TRANSITION_DELAY_BASE = 200;
export const TRANSITION_DELAY_LONG = 400;
export const TRANSITION_DURATION_INSTANT = 0;
export const TRANSITION_DURATION_EXTRA_SHORT = 50;
export const TRANSITION_DURATION_SHORT = 150;
export const TRANSITION_DURATION_BASE = 250;
export const TRANSITION_DURATION_LONG = 500;
export const TRANSITION_DURATION_EXTRA_LONG = 1000;
export const FONT_FAMILY_TITLES = "'Ivy Ora Display', serif";
export const FONT_FAMILY_BODY = "'Figtree', sans-serif";
export const FONT_SIZE_XXS = 12;
export const FONT_SIZE_XS = 14;
export const FONT_SIZE_S = 16;
export const FONT_SIZE_M = 18;
export const FONT_SIZE_L = 20;
export const FONT_SIZE_XL = 22;
export const FONT_SIZE_2XL = 24;
export const FONT_SIZE_3XL = 28;
export const FONT_SIZE_4XL = 32;
export const FONT_SIZE_5XL = 36;
export const FONT_SIZE_6XL = 40;
export const FONT_SIZE_7XL = 44;
export const FONT_SIZE_8XL = 48;
export const FONT_SIZE_9XL = 52;
export const FONT_SIZE_10XL = 56;
export const FONT_SIZE_11XL = 60;
export const FONT_SIZE_12XL = 64;
export const FONT_SIZE_13XL = 68;
export const FONT_SIZE_14XL = 72;
export const FONT_SIZE_BASE = 18;
export const FONT_WEIGHT_THIN = 100;
export const FONT_WEIGHT_LIGHT = 300;
export const FONT_WEIGHT_REGULAR = 400;
export const FONT_WEIGHT_MEDIUM = 500;
export const FONT_WEIGHT_BOLD = 700;
export const LINE_HEIGHT_XXS = 16;
export const LINE_HEIGHT_XS = 24;
export const LINE_HEIGHT_S = 32;
export const LINE_HEIGHT_M = 40;
export const LINE_HEIGHT_L = 48;
export const LINE_HEIGHT_XL = 56;
export const LINE_HEIGHT_XXL = 64;
export const LETTER_SPACING_SMALL = 0;
export const LETTER_SPACING_MEDIUM = 2;
export const LETTER_SPACING_LARGE = 4;
